import { call, select, takeEvery } from 'redux-saga/effects';

import { TRACK_IMAGE_SEARCH, TrackImageSearchAction } from 'js/actionCreators/trackingActions';
import { NAVIGATE_TO_CHARACTERS, SELECT_CHARACTER, SelectCharacterAction } from 'js/actionCreators/imageSearchActions';
import { getImageSearchFilters, getImageSearchMode, getSelectedCharacter } from 'js/sagas/selectors';

import { track } from '../mixpanelProvider';
import { imageSourceToMixpanelName } from '../../sagaHelpers/imageSourceToMixpanelName';

export function* trackSearchImage({ query, scribeId, tab }: TrackImageSearchAction) {
  const { filters }: ReturnType<typeof getImageSearchFilters> = yield select(getImageSearchFilters);
  const activeSearchMode: ReturnType<typeof getImageSearchMode> = yield select(getImageSearchMode);

  if (query.length === 0) {
    return;
  }

  const selectedFilters: { name: string; value: string }[] = [];
  filters.forEach(filter => {
    filter.values.forEach(value => {
      if (value.selected) {
        selectedFilters.push({ name: filter.title, value: value.name });
      }
    });
  });

  const tabName = imageSourceToMixpanelName[tab] || 'No Tab';

  if (activeSearchMode !== 'character') {
    yield call(track, 'Search For Image', {
      'Scribe ID': scribeId,
      'Search Term': query,
      Tab: tabName,
      Filters: selectedFilters.length > 0 ? selectedFilters : undefined
    });
  }

  if (activeSearchMode === 'character') {
    const { characterName, characterStyle }: ReturnType<typeof getSelectedCharacter> =
      yield select(getSelectedCharacter);
    yield call(track, 'Search Character Profile', {
      'Character Name': characterName,
      'Character Style': characterStyle,
      'Search Term': query
    });
  }
}

function* trackNavigateToCharacters() {
  yield call(track, 'Character Banner Clicked');
}

function* trackSelectCharacter({ characterName, characterStyle }: SelectCharacterAction) {
  yield call(track, 'View Character Profile', {
    'Character Name': characterName,
    'Character Style': characterStyle
  });
}

export default function* trackImageDrawerSagas() {
  yield takeEvery(TRACK_IMAGE_SEARCH, trackSearchImage);
  yield takeEvery(NAVIGATE_TO_CHARACTERS, trackNavigateToCharacters);
  yield takeEvery(SELECT_CHARACTER, trackSelectCharacter);
}
